var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath181(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.15,
    height: 20.633,
    viewBox: "95.027 26.371 12.15 20.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.984 27.847c-1.084-.923-2.412-1.476-3.876-1.476s-2.793.553-3.877 1.476c-2.386 2.055-2.874 5.612-1.274 8.327l4.69 9.144h-.38l.868 1.686.867-1.686h-.352l4.608-9.144c1.573-2.688 1.112-6.272-1.274-8.327Zm.597 5.349c-.244 1.95-1.87 3.531-3.877 3.768-2.955.37-5.422-2.055-5.042-4.901.244-1.95 1.87-3.531 3.876-3.768 2.928-.37 5.395 2.029 5.043 4.901Zm0 0",
    fill: "#d2ebb5",
    fillRule: "evenodd",
    "data-name": "Path 181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath181);
export default __webpack_public_path__ + "static/media/Path 181.67d269db9cffd3bce7549a2ba019e6de.svg";
export { ForwardRef as ReactComponent };